angular.module('rjmNg.filters').filter "multiword", () ->
    # Given a search text and inputs, find any of the words in the search text
    (input,searchText) ->
      if not searchText? then return input
      result = []
      search = new RegExp(searchText.toLowerCase().replace(/ /g,'|'))
      result.push value for value in input when search.test(value.toLowerCase())
      return result
